import React, { useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";

import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { useNavigate } from "react-router-dom";
import { Alert, Snackbar } from "@mui/material";




import * as XLSX from "xlsx";
import UtilsFormule from "../utils/UtilsFormule";

const DataTableTraite = ({ tickets }) => {
  const navigate = useNavigate();
  const [onAddPayement, setOnAddPayement] = useState(false);
  const [onRejeterPayement, setOnRejeterPayement] = useState(false);
  const [onRejeterDefPayement, setOnRejeterDefPayement] = useState(false);

  const [idPayement, setIdPayement] = useState();

  const [infoAlertText, setInfoAlertText] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);

  const { SearchBar } = Search;



  const CustomExportButton = ({ data, fileName }) => {
    const handleExport = () => {
      console.log("data", data);
      // Filter the data to include only the required fields
      const filteredData = data.map((item) => ({
        Ref: (() => {
          if (item.typePayement === "Espéce") {
            return item.refPayementInfo + "-" + item.yearPayementInfo;
          } else if (item.typePayement === "Virement") {
            return item.numVirement || "";
          } else if (item.typePayement === "Chéque / Traites") {
            return item.codeCheque || "";
          } else if (item.typePayement === "En ligne") {
            return item.ref;
          } else {
            return item.ref
          }
        })(), // Immediately invoke the function
        Type: item.typePayement,
        Echéance: (() => {
          if (
            item.typePayement === "Espéce" ||
            item.typePayement === "En ligne"
          ) {
            return UtilsFormule.formatDate(item.dateCreation);
          } else if (
            item.typePayement === "Virement" ||
            item.typePayement === "Chéque / Traites"
          ) {
            return UtilsFormule.formatDate(item.dateEcheance);
          } else {
            return UtilsFormule.formatDate(item.dateCreation);
          }
        })(),
        "M.payé": item.amountPayed,

      }));

      // Convert the filtered data to a worksheet
      const ws = XLSX.utils.json_to_sheet(filteredData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

      // Export the workbook to an Excel file
      XLSX.writeFile(wb, `${fileName}.xlsx`);
    };

    return (
      <button onClick={handleExport} className="btn btn-dark">
        <i className="fas fa-download"></i> Télécharger Excel
      </button>
    );
  };


  function RefPayementFormatter(cell, row) {

    if (row.typePayement === "Espéce") {
      return (
        <span >
          {row.ref}-{row.year}
        </span>
      );
    } else if (row.typePayement === "Virement") {
      return (
        <span >
          {row.numVirement}
        </span>
      );
    }
    else if (row.typePayement === "Chéque / Traites") {
      return (
        <span >
          {row.codeCheque}
        </span>
      );
    } else if (row.typePayement === "Prélevement") {
      return (
        <span >
          Prélevement
        </span>
      );
    }
    else {
      return (
        <span >
          {row.ref}
        </span>
      );
    }


  }
   function dateCreationFormatter(cell, row) {

    if (row.typePayement === "Espéce" || row.typePayement === "En ligne") {
      return (
        <span >
          {UtilsFormule.formatDate(row.dateCreation)}
        </span>
      );
    } else if (row.typePayement === "Virement" || row.typePayement === "Chéque / Traites") {
      return (
        <span >
          {UtilsFormule.formatDate(row.dateCreation)}
        </span>
      );
    }



  }
  function dateFormatter(cell, row) {

    if (row.typePayement === "Espéce" || row.typePayement === "En ligne") {
      return (
        <span >
          {UtilsFormule.formatDate(row.dateCreation)}
        </span>
      );
    } else if (row.typePayement === "Virement" || row.typePayement === "Chéque / Traites") {
      return (
        <span >
          {UtilsFormule.formatDate(row.dateEcheance)}
        </span>
      );
    }



  }


  function referenceFormatter(cell, row) {
    switch (row?.typePayement) {
      case "Espéce":
        return row.ref + "-" + row.year;
      case "En ligne":
        return row.ref;
      case "Chéque / Traites":
        return row.codeCheque;
      case "Virement":
        return row.numVirement;
      case "CarteCadeau":
        return row.ref + "-" + row.year;
      case "RSS":
        return row.reference;
      default:
        return null;
    }
  }

  const onViewEchangePayementHandler = (row) => {
    sessionStorage.setItem("idPayementEchange", row?.id);
    sessionStorage.setItem("refPayementEchange", referenceFormatter("", row));
    sessionStorage.setItem("typePayementEchange", row?.typePayement);

    sessionStorage.setItem("amountPayementEchange", row?.amountPayed);
    const pdfWindow = window.open();
    pdfWindow.location.href = "/echangePaiementTraite";
    // navigate("/getDocumentSalesByRef");
  };
  function buttonDeleteFormatter(cell, row) {
    if(row.typePayementValidation=="none"||row.typePayementValidation=="refuse"){
 return (
      <span>
        <button
          className="btn btn-dark"
          onClick={() => onViewEchangePayementHandler(row)}
        >
          <h6>
            <small>
              <i class="fas fa-money-bill-transfer"></i>
            </small>
          </h6>
        </button>
      </span>
    );
    }else{
      return <></>
    }
   
  }

  const columns = [
    {
      dataField: "id",
      text: "Ref",
      align: "center",
      formatter: RefPayementFormatter,
      headerAlign: "center",
      headerStyle: () => {
        return { width: "20%" };
      },
    },
    {
      dataField: "emetteur",
      text: "Emetteur",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "20%" };
      },
    },
    {
      dataField: "documentRef",
      text: "",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "25%" };
      },
    },
    {
      dataField: "typePayement",
      text: "Type",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "20%" };
      },
    },
    {
      dataField: "id",
      text: "D.Creation",
      formatter: dateCreationFormatter,
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "15%" };
      },
    },
    {
      dataField: "id",
      text: "D.Echeance",
      formatter: dateFormatter,
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "15%" };
      },
    },
    {
      dataField: "amountPayed",
      text: "M.Payé",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "15%" };
      },
    },


    {
      dataField: "id",
      text: "Payer",
      formatter: buttonDeleteFormatter,
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "12%" };
      },
    },
  ];

  const especeInfo = (row) => {
    if (row.typePayementValidation === "accept") {
      return (
        <>{row.descriptionOperation !== null && <p>
          {row.descriptionOperation}
        </p>}
          <table
            class="table table-striped table-bordered table-sm"
            cellspacing="0"
            width="100%"
          >
            <thead>
              <tr className="text-center">
                <th style={{ width: "15%" }}>Payement</th>

                <th style={{ width: "15%" }}>Type payement</th>
                <th style={{ width: "15%" }}>Ref</th>
                <th style={{ width: "15%" }}>DC</th>
                <th style={{ width: "15%" }}>M.Payé</th>
                <th style={{ width: "15%" }}>Ref.Opération</th>
                <th style={{ width: "15%" }}>Date Opération</th>
                <th style={{ width: "15%" }}>Date Valeur</th>
              </tr>
            </thead>
            <tbody>
              <tr key={row.idPayementInfo}>
                <td>Accepté</td>
                <td>Espèce</td>
                <td>{row.ref}-{row.year}</td>
                <td>{UtilsFormule.formatDateHours(row.dateCreation)} </td>
                <td className="text-center">{row.amountPayed} </td>
                <td className="text-center">{row.refOperation} </td>
                <td className="text-center">{UtilsFormule.formatDateHours(row.operationDate)} </td>
                <td className="text-center">{UtilsFormule.formatDateHours(row.valeurDate)} </td>
              </tr>
            </tbody>
          </table></>)
    } else if (row.typePayementValidation === "refuse") {
      return (
        <>{row.descriptionOperation !== null && <p>
          {row.descriptionOperation}
        </p>}
          <table
            class="table table-striped table-bordered table-sm"
            cellspacing="0"
            width="100%"
          >
            <thead>
              <tr className="text-center">
                <th style={{ width: "15%" }}>Payement</th>
                <th style={{ width: "15%" }}>Type payement</th>
                <th style={{ width: "15%" }}>Ref</th>
                <th style={{ width: "15%" }}>DC</th>
                <th style={{ width: "15%" }}>M.Payé</th>
                <th style={{ width: "15%" }}>Date Refus</th>
                <th style={{ width: "15%" }}>Payer</th>
                <th style={{ width: "15%" }}>Rejeter définitivement</th>
              </tr>
            </thead>
            <tbody>
              <tr key={row.idPayementInfo}>
                <td>Rejeté</td>
                <td>Espèce</td>
                <td>{row.ref}-{row.year}</td>
                <td>{UtilsFormule.formatDateHours(row.dateCreation)} </td>
                <td className="text-center">{row.amountPayed} </td>
                <td className="text-center">{UtilsFormule.formatDateHours(row.rejectDate)} </td>


              </tr>
            </tbody>
          </table></>)
    } else if (row.typePayementValidation === "refuse-def") {
      return (
        <>{row.descriptionOperation !== null && <p>
          {row.descriptionOperation}
        </p>}
          <table
            class="table table-striped table-bordered table-sm"
            cellspacing="0"
            width="100%"
          >
            <thead>
              <tr className="text-center">
                <th style={{ width: "15%" }}>Payement</th>
                <th style={{ width: "15%" }}>Type payement</th>
                <th style={{ width: "15%" }}>Ref</th>
                <th style={{ width: "15%" }}>DC</th>
                <th style={{ width: "15%" }}>M.Payé</th>
                <th style={{ width: "15%" }}>Date Opération</th>
              </tr>
            </thead>
            <tbody>
              <tr key={row.idPayementInfo}>
                <td>Refusé définitivement</td>
                <td>Espèce</td>
                <td>{row.ref}-{row.year}</td>
                <td>{UtilsFormule.formatDateHours(row.dateCreation)} </td>
                <td className="text-center">{row.amountPayed} </td>
                <td className="text-center">{UtilsFormule.formatDateHours(row.operationDate)} </td>
              </tr>
            </tbody>
          </table></>)
    } else {
      return (<table
        class="table table-striped table-bordered table-sm"
        cellspacing="0"
        width="100%"
      >
        <thead>
          <tr className="text-center">
            <th style={{ width: "15%" }}>Type payement</th>
            <th style={{ width: "15%" }}>Ref</th>
            <th style={{ width: "15%" }}>DC</th>
            <th style={{ width: "15%" }}>M.Payé</th>
            <th style={{ width: "15%" }}>Payer</th>
            <th style={{ width: "15%" }}>Rejeter</th>
            <th style={{ width: "15%" }}>Rejeter définitivement</th>

          </tr>
        </thead>
        <tbody>
          <tr key={row.idPayementInfo}>
            <td>Espèce</td>
            <td>{row.ref}-{row.year}</td>
            <td>{UtilsFormule.formatDateHours(row.dateCreation)} </td>
            <td className="text-center">{row.amountPayed} </td>




          </tr>

        </tbody>
      </table>)
    }
  }
  const enLigneInfo = (row) => {
    if (row.typePayementValidation === "accept") {
      return (
        <>{row.descriptionOperation !== null && <p>
          {row.descriptionOperation}
        </p>}
          <table
            class="table table-striped table-bordered table-sm"
            cellspacing="0"
            width="100%"
          >
            <thead>
              <tr className="text-center">
                <th style={{ width: "15%" }}>Payement</th>

                <th style={{ width: "15%" }}>Type payement</th>
                <th style={{ width: "15%" }}>Ref</th>
                <th style={{ width: "15%" }}>DC</th>
                <th style={{ width: "15%" }}>M.Payé</th>
                <th style={{ width: "15%" }}>Ref.Opération</th>
                <th style={{ width: "15%" }}>Date Opération</th>
                <th style={{ width: "15%" }}>Date Valeur</th>
              </tr>
            </thead>
            <tbody>
              <tr key={row.idPayementInfo}>
                <td>Accepté</td>
                <td>En ligne</td>
                <td>{row.ref}-{row.year}</td>
                <td>{UtilsFormule.formatDateHours(row.dateCreation)} </td>
                <td className="text-center">{row.amountPayed} </td>
                <td className="text-center">{row.refOperation} </td>
                <td className="text-center">{UtilsFormule.formatDateHours(row.operationDate)} </td>
                <td className="text-center">{UtilsFormule.formatDateHours(row.valeurDate)} </td>
              </tr>
            </tbody>
          </table></>)
    } else if (row.typePayementValidation === "refuse") {
      return (
        <>{row.descriptionOperation !== null && <p>
          {row.descriptionOperation}
        </p>}
          <table
            class="table table-striped table-bordered table-sm"
            cellspacing="0"
            width="100%"
          >
            <thead>
              <tr className="text-center">
                <th style={{ width: "15%" }}>Payement</th>
                <th style={{ width: "15%" }}>Type payement</th>
                <th style={{ width: "15%" }}>Ref</th>
                <th style={{ width: "15%" }}>DC</th>
                <th style={{ width: "15%" }}>M.Payé</th>
                <th style={{ width: "15%" }}>Date Refus</th>
                <th style={{ width: "15%" }}>Payer</th>
                <th style={{ width: "15%" }}>Rejeter définitivement</th>

              </tr>
            </thead>
            <tbody>
              <tr key={row.idPayementInfo}>
                <td>Rejeté</td>
                <td>En ligne</td>
                <td>{row.ref}-{row.year}</td>
                <td>{UtilsFormule.formatDateHours(row.dateCreation)} </td>
                <td className="text-center">{row.amountPayed} </td>
                <td className="text-center">{UtilsFormule.formatDateHours(row.rejectDate)} </td>


              </tr>
            </tbody>
          </table></>)
    } else if (row.typePayementValidation === "refuse-def") {
      return (
        <>{row.descriptionOperation !== null && <p>
          {row.descriptionOperation}
        </p>}
          <table
            class="table table-striped table-bordered table-sm"
            cellspacing="0"
            width="100%"
          >
            <thead>
              <tr className="text-center">
                <th style={{ width: "15%" }}>Payement</th>
                <th style={{ width: "15%" }}>Type payement</th>
                <th style={{ width: "15%" }}>Ref</th>
                <th style={{ width: "15%" }}>DC</th>
                <th style={{ width: "15%" }}>M.Payé</th>
                <th style={{ width: "15%" }}>Date Opération</th>
              </tr>
            </thead>
            <tbody>
              <tr key={row.idPayementInfo}>
                <td>Refusé définitivement</td>
                <td>En ligne</td>
                <td>{row.ref}-{row.year}</td>
                <td>{UtilsFormule.formatDateHours(row.dateCreation)} </td>
                <td className="text-center">{row.amountPayed} </td>
                <td className="text-center">{UtilsFormule.formatDateHours(row.operationDate)} </td>
              </tr>
            </tbody>
          </table></>)
    } else {
      return (<table
        class="table table-striped table-bordered table-sm"
        cellspacing="0"
        width="100%"
      >
        <thead>
          <tr className="text-center">
            <th style={{ width: "15%" }}>Type payement</th>
            <th style={{ width: "15%" }}>Ref</th>
            <th style={{ width: "15%" }}>DC</th>
            <th style={{ width: "15%" }}>M.Payé</th>
            <th style={{ width: "15%" }}>Payer</th>
            <th style={{ width: "15%" }}>Rejeter</th>
            <th style={{ width: "15%" }}>Rejeter définitivement</th>

          </tr>
        </thead>
        <tbody>
          <tr key={row.idPayementInfo}>
            <td>En ligne</td>
            <td>{row.ref}-{row.year}</td>
            <td>{UtilsFormule.formatDateHours(row.dateCreation)} </td>


            <td className="text-center">{row.amountPayed} </td>




          </tr>

        </tbody>
      </table>)
    }


  }
  const virementInfo = (row) => {

    if (row.typePayementValidation === "accept") {
      return (
        <>{row.descriptionOperation !== null && <p>
          {row.descriptionOperation}
        </p>}
          <table
            class="table table-striped table-bordered table-sm"
            cellspacing="0"
            width="100%"
          >
            <thead>
              <tr className="text-center">
                <th style={{ width: "15%" }}>Payement</th>

                <th style={{ width: "15%" }}>Type payement</th>
                <th style={{ width: "15%" }}>Ref</th>
                <th style={{ width: "15%" }}>DC</th>
                <th style={{ width: "15%" }}>M.Payé</th>
                <th style={{ width: "15%" }}>Ref.Opération</th>
                <th style={{ width: "15%" }}>Date Opération</th>
                <th style={{ width: "15%" }}>Date Valeur</th>
              </tr>
            </thead>
            <tbody>
              <tr key={row.idPayementInfo}>
                <td>Accepté</td>
                <td>Virement</td>
                <td>{row.numVirement}</td>
                <td>{UtilsFormule.formatDateHours(row.dateCreation)} </td>
                <td className="text-center">{row.amountPayed} </td>
                <td className="text-center">{row.refOperation} </td>
                <td className="text-center">{UtilsFormule.formatDateHours(row.operationDate)} </td>
                <td className="text-center">{UtilsFormule.formatDateHours(row.valeurDate)} </td>
              </tr>
            </tbody>
          </table></>)
    } else if (row.typePayementValidation === "refuse") {
      return (
        <>{row.descriptionOperation !== null && <p>
          {row.descriptionOperation}
        </p>}
          <table
            class="table table-striped table-bordered table-sm"
            cellspacing="0"
            width="100%"
          >
            <thead>
              <tr className="text-center">
                <th style={{ width: "15%" }}>Payement</th>
                <th style={{ width: "15%" }}>Type payement</th>
                <th style={{ width: "15%" }}>Ref</th>
                <th style={{ width: "15%" }}>DC</th>
                <th style={{ width: "15%" }}>M.Payé</th>
                <th style={{ width: "15%" }}>Date Refus</th>
                <th style={{ width: "15%" }}>Payer</th>
                <th style={{ width: "15%" }}>Rejeter définitivement</th>

              </tr>
            </thead>
            <tbody>
              <tr key={row.idPayementInfo}>
                <td>Rejeté</td>
                <td>Virement</td>
                <td>{row.numVirement}</td>
                <td>{UtilsFormule.formatDateHours(row.dateCreation)} </td>
                <td className="text-center">{row.amountPayed} </td>
                <td className="text-center">{UtilsFormule.formatDateHours(row.rejectDate)} </td>


              </tr>
            </tbody>
          </table></>)
    } else if (row.typePayementValidation === "refuse-def") {
      return (
        <>{row.descriptionOperation !== null && <p>
          {row.descriptionOperation}
        </p>}
          <table
            class="table table-striped table-bordered table-sm"
            cellspacing="0"
            width="100%"
          >
            <thead>
              <tr className="text-center">
                <th style={{ width: "15%" }}>Payement</th>
                <th style={{ width: "15%" }}>Type payement</th>
                <th style={{ width: "15%" }}>Ref</th>
                <th style={{ width: "15%" }}>DC</th>
                <th style={{ width: "15%" }}>M.Payé</th>
                <th style={{ width: "15%" }}>Date Opération</th>
              </tr>
            </thead>
            <tbody>
              <tr key={row.idPayementInfo}>
                <td>Refusé définitivement</td>
                <td>Virement</td>
                <td>{row.numVirement}</td>
                <td>{UtilsFormule.formatDateHours(row.dateCreation)} </td>
                <td className="text-center">{row.amountPayed} </td>
                <td className="text-center">{UtilsFormule.formatDateHours(row.operationDate)} </td>
              </tr>
            </tbody>
          </table></>)
    } else {
      return (<table
        class="table table-striped table-bordered table-sm"
        cellspacing="0"
        width="100%"
      >
        <thead>
          <tr className="text-center">
            <th style={{ width: "15%" }}>Type payement</th>
            <th style={{ width: "15%" }}>Ref</th>
            <th style={{ width: "15%" }}>DC</th>
            <th style={{ width: "15%" }}>M.Payé</th>
            <th style={{ width: "15%" }}>Payer</th>
            <th style={{ width: "15%" }}>Rejeter</th>
            <th style={{ width: "15%" }}>Rejeter définitivement</th>

          </tr>
        </thead>
        <tbody>
          <tr key={row.idPayementInfo}>
            <td>Virement</td>
            <td>{row.numVirement}</td>
            <td>{UtilsFormule.formatDateHours(row.dateCreation)} </td>


            <td className="text-center">{row.amountPayed} </td>




          </tr>

        </tbody>
      </table>)
    }
  }

  const chequeInfo = (row) => {
    if (row.typePayementValidation === "echange") {
      return (
        <>{row.descriptionOperation !== null && <p>
          {row.descriptionOperation}
        </p>}
          <table
            class="table table-striped table-bordered table-sm"
            cellspacing="0"
            width="100%"
          >
            <thead>
              <tr className="text-center">
                <th style={{ width: "15%" }}>Payement</th>

                {/* <th style={{ width: "15%" }}>Type payement</th>
                <th style={{ width: "15%" }}>Ref.Cheque</th>
                <th style={{ width: "15%" }}>DC</th> */}
                <th style={{ width: "15%" }}>M.Payé</th>
                {/* <th style={{ width: "15%" }}>Ref.Opération</th>
                <th style={{ width: "15%" }}>Date Opération</th> */}
                <th style={{ width: "15%" }}>Date Payement</th>
              </tr>
            </thead>
            <tbody>
              <tr key={row.idPayementInfo}>
                <td>Echange</td>
                {/* <td>Chèque/ traites</td>
                <td>{row.codeCheque}</td>
                <td>{UtilsFormule.formatDateHours(row.dateCreation)} </td> */}
                <td className="text-center">{row.amountPayed} </td>
                <td className="text-center">{UtilsFormule.formatDateHours(row.rejectDate)} </td>
              </tr>
            </tbody>
          </table></>)
    } if (row.typePayementValidation === "accept") {
      return (
        <>{row.descriptionOperation !== null && <p>
          {row.descriptionOperation}
        </p>}
          <table
            class="table table-striped table-bordered table-sm"
            cellspacing="0"
            width="100%"
          >
            <thead>
              <tr className="text-center">
                <th style={{ width: "15%" }}>Payement</th>

                <th style={{ width: "15%" }}>Type payement</th>
                <th style={{ width: "15%" }}>Ref.Cheque</th>
                <th style={{ width: "15%" }}>DC</th>
                <th style={{ width: "15%" }}>M.Payé</th>
                <th style={{ width: "15%" }}>Ref.Opération</th>
                <th style={{ width: "15%" }}>Date Opération</th>
                <th style={{ width: "15%" }}>Date Valeur</th>
              </tr>
            </thead>
            <tbody>
              <tr key={row.idPayementInfo}>
                <td>Accepté</td>
                <td>Chèque/ traites</td>
                <td>{row.codeCheque}</td>
                <td>{UtilsFormule.formatDateHours(row.dateCreation)} </td>
                <td className="text-center">{row.amountPayed} </td>
                <td className="text-center">{row.refOperation} </td>
                <td className="text-center">{UtilsFormule.formatDateHours(row.operationDate)} </td>
                <td className="text-center">{UtilsFormule.formatDateHours(row.valeurDate)} </td>
              </tr>
            </tbody>
          </table></>)
    } else if (row.typePayementValidation === "refuse") {
      return (
        <>{row.descriptionOperation !== null && <p>
          {row.descriptionOperation}
        </p>}
          <table
            class="table table-striped table-bordered table-sm"
            cellspacing="0"
            width="100%"
          >
            <thead>
              <tr className="text-center">
                <th style={{ width: "15%" }}>Payement</th>
                <th style={{ width: "15%" }}>Type payement</th>
                <th style={{ width: "15%" }}>Ref.Cheque</th>
                <th style={{ width: "15%" }}>DC</th>
                <th style={{ width: "15%" }}>M.Payé</th>
                <th style={{ width: "15%" }}>Date Refus</th>


              </tr>
            </thead>
            <tbody>
              <tr key={row.idPayementInfo}>
                <td>Rejeté</td>
                <td>Chèque/ traites</td>
                <td>{row.codeCheque}</td>
                <td>{UtilsFormule.formatDateHours(row.dateCreation)} </td>
                <td className="text-center">{row.amountPayed} </td>
                <td className="text-center">{UtilsFormule.formatDateHours(row.rejectDate)} </td>
              </tr>
            </tbody>
          </table></>)
    } else if (row.typePayementValidation === "refuse-def") {
      return (
        <>{row.descriptionOperation !== null && <p>
          {row.descriptionOperation}
        </p>}
          <table
            class="table table-striped table-bordered table-sm"
            cellspacing="0"
            width="100%"
          >
            <thead>
              <tr className="text-center">
                <th style={{ width: "15%" }}>Payement</th>
                <th style={{ width: "15%" }}>Type payement</th>
                <th style={{ width: "15%" }}>Ref</th>
                <th style={{ width: "15%" }}>DC</th>
                <th style={{ width: "15%" }}>M.Payé</th>
                <th style={{ width: "15%" }}>Date Opération</th>
              </tr>
            </thead>
            <tbody>
              <tr key={row.idPayementInfo}>
                <td>Refusé définitivement</td>
                <td>Chèque/ traites</td>
                <td>{row.codeCheque}</td>
                <td>{UtilsFormule.formatDateHours(row.dateCreation)} </td>
                <td className="text-center">{row.amountPayed} </td>
                <td className="text-center">{UtilsFormule.formatDateHours(row.operationDate)} </td>
              </tr>
            </tbody>
          </table></>)
    } else {
      return (<table
        class="table table-striped table-bordered table-sm"
        cellspacing="0"
        width="100%"
      >
        <thead>
          <tr className="text-center">
            <th style={{ width: "15%" }}>Payement</th>
            <th style={{ width: "15%" }}>Type payement</th>
            <th style={{ width: "15%" }}>Ref.Cheque</th>
            <th style={{ width: "15%" }}>DC</th>
            <th style={{ width: "15%" }}>M.Payé</th>
          </tr>
        </thead>
        <tbody>

          <tr key={row.idPayementInfo}>
            <td>Non Rapproché</td>
            <td>Chèque/ traites</td>
            <td>{row.codeCheque}</td>
            <td>{UtilsFormule.formatDateHours(row.dateCreation)} </td>
            <td className="text-center">{row.amountPayed} </td>
          </tr>

        </tbody>
      </table>)
    }


  }
  const prelevementInfo = (row) => {


    if (row.typePayementValidation === "accept") {
      return (
        <>{row.descriptionOperation !== null && <p>
          {row.descriptionOperation}
        </p>}
          <table
            class="table table-striped table-bordered table-sm"
            cellspacing="0"
            width="100%"
          >
            <thead>
              <tr className="text-center">
                <th style={{ width: "15%" }}>Payement</th>

                <th style={{ width: "15%" }}>Type payement</th>
                <th style={{ width: "15%" }}>Ref</th>
                <th style={{ width: "15%" }}>DC</th>
                <th style={{ width: "15%" }}>M.Payé</th>
                <th style={{ width: "15%" }}>Ref.Opération</th>
                <th style={{ width: "15%" }}>Date Opération</th>
                <th style={{ width: "15%" }}>Date Valeur</th>
              </tr>
            </thead>
            <tbody>
              <tr key={row.idPayementInfo}>
                <td>Accepté</td>
                <td>Prélevement</td>
                <td>{row.ref}-{row.year}</td>
                <td>{UtilsFormule.formatDateHours(row.dateCreation)} </td>
                <td className="text-center">{row.amountPayed} </td>
                <td className="text-center">{row.refOperation} </td>
                <td className="text-center">{UtilsFormule.formatDateHours(row.operationDate)} </td>
                <td className="text-center">{UtilsFormule.formatDateHours(row.valeurDate)} </td>
              </tr>
            </tbody>
          </table></>)
    } else if (row.typePayementValidation === "refuse") {
      return (
        <>{row.descriptionOperation !== null && <p>
          {row.descriptionOperation}
        </p>}
          <table
            class="table table-striped table-bordered table-sm"
            cellspacing="0"
            width="100%"
          >
            <thead>
              <tr className="text-center">
                <th style={{ width: "15%" }}>Payement</th>
                <th style={{ width: "15%" }}>Type payement</th>
                <th style={{ width: "15%" }}>Ref</th>
                <th style={{ width: "15%" }}>DC</th>
                <th style={{ width: "15%" }}>M.Payé</th>
                <th style={{ width: "15%" }}>Date Refus</th>

              </tr>
            </thead>
            <tbody>
              <tr key={row.idPayementInfo}>
                <td>Rejeté</td>
                <td>Prélevement</td>
                <td>{row.ref}-{row.year}</td>
                <td>{UtilsFormule.formatDateHours(row.dateCreation)} </td>
                <td className="text-center">{row.amountPayed} </td>
                <td className="text-center">{UtilsFormule.formatDateHours(row.rejectDate)} </td>

              </tr>
            </tbody>
          </table></>)
    } else if (row.typePayementValidation === "refuse-def") {
      return (
        <>{row.descriptionOperation !== null && <p>
          {row.descriptionOperation}
        </p>}
          <table
            class="table table-striped table-bordered table-sm"
            cellspacing="0"
            width="100%"
          >
            <thead>
              <tr className="text-center">
                <th style={{ width: "15%" }}>Payement</th>
                <th style={{ width: "15%" }}>Type payement</th>
                <th style={{ width: "15%" }}>Ref</th>
                <th style={{ width: "15%" }}>DC</th>
                <th style={{ width: "15%" }}>M.Payé</th>
                <th style={{ width: "15%" }}>Date Opération</th>
              </tr>
            </thead>
            <tbody>
              <tr key={row.idPayementInfo}>
                <td>Refusé définitivement</td>
                <td>Prélevement</td>
                <td>{row.ref}-{row.year}</td>
                <td>{UtilsFormule.formatDateHours(row.dateCreation)} </td>
                <td className="text-center">{row.amountPayed} </td>
                <td className="text-center">{UtilsFormule.formatDateHours(row.operationDate)} </td>
              </tr>
            </tbody>
          </table></>)
    } else {
      return (<table
        class="table table-striped table-bordered table-sm"
        cellspacing="0"
        width="100%"
      >
        <thead>
          <tr className="text-center">
            <th style={{ width: "15%" }}>Type payement</th>
            <th style={{ width: "15%" }}>Ref</th>
            <th style={{ width: "15%" }}>DC</th>
            <th style={{ width: "15%" }}>M.Payé</th>

          </tr>
        </thead>
        <tbody>
          <tr key={row.idPayementInfo}>
            <td>Prélevement</td>
            <td>{row.ref}-{row.year}</td>
            <td>{UtilsFormule.formatDateHours(row.dateCreation)} </td>
            <td className="text-center">{row.amountPayed} </td>
          </tr>

        </tbody>
      </table>)
    }


  }
  const expandRow = {
    renderer: (row) => (
      <div>
        {row.typePayement === "Espéce" && especeInfo(row)}
        {row.typePayement === "En ligne" && enLigneInfo(row)}
        {row.typePayement === "Chéque / Traites" && chequeInfo(row)}
        {row.typePayement === "Virement" && virementInfo(row)}
        {row.typePayement === "Prélevement" && prelevementInfo(row)}
      </div>
    ),
    showExpandColumn: true,
    expandHeaderColumnRenderer: ({ isAnyExpands }) => {
      if (isAnyExpands) {
        return <b style={{ cursor: "pointer" }}>-</b>;
      }
      return <b style={{ cursor: "pointer" }}>+</b>;
    },
    expandColumnRenderer: ({ expanded }) => {
      if (expanded) {
        return <b style={{ cursor: "pointer" }}>-</b>;
      }
      return <b style={{ cursor: "pointer" }}>+</b>;
    },
  };

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };

  function handleTableChange({ products }) {
    return products;
  }
  const pageButtonRenderer = ({
    page,
    active,
    disable,
    title,
    onPageChange,
  }) => {
    const handleClick = (e) => {
      e.preventDefault();
      onPageChange(page);
    };
    const activeStyle = {};
    if (active) {
      activeStyle.backgroundColor = "black";
      activeStyle.color = "white";
    } else {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    if (typeof page === "string") {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    return (
      <li className="page-item">
        <button
          className="btn btn-dark"
          onClick={handleClick}
          style={activeStyle}
        >
          {page}
        </button>
      </li>
    );
  };
  const options = {
    pageButtonRenderer,
  };

  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">Les transactions </h3>
      </div>
      <div className="card-body">
        <ToolkitProvider
          keyField="id"
          data={tickets}
          columns={columns}
          onTableChange={handleTableChange}
          exportCSV
          search
        >
          {(props) => (
            <div>
              <div className="row ml-0">
                <div>
                  <SearchBar
                    {...props.searchProps}
                    className="custome-search-field"
                    style={{ color: "black" }}
                    placeholder="Chercher"
                  ></SearchBar>
                </div>
                {/* <div className="ml-auto mr-0">
                  <CustomExportButton
                    data={listTransaction}
                    fileName="transactions"
                  />
                </div> */}
              </div>
              <div className="row">
                <BootstrapTable
                  {...props.baseProps}
                  pagination={paginationFactory(options)}
                  striped
                  hover
                  condensed
                  expandRow={expandRow}
                />
              </div>
            </div>
          )}
        </ToolkitProvider>
      </div>

      {openInfoAlert && (
        <Snackbar
          open={openInfoAlert}
          autoHideDuration={2000}
          onClose={handleInfoClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          <Alert variant="filled" onClose={handleInfoClose} severity="info">
            {infoAlertText}
          </Alert>
        </Snackbar>
      )}

    </div>
  );
};
export default DataTableTraite;
